<template>
  <!-- 底部 -->
  <div class="footer-container">
    <div class="link-container">
      <div class="link-box">
        <div class="link-list">
          <div class="link-list-item">
            <a class="single-link" href="https://www.gov.cn/" target="_blank">中国政府网</a>
          </div>
          <div class="link-list-item">
            <a class="single-link" href="https://www.miit.gov.cn/zwgk/index.html" target="_blank">工业和信息化部网站</a>
          </div>
          <div class="link-list-item">
            <a class="single-link" href="https://www.cq.gov.cn/" target="_blank">重庆市人民政府网站</a>
          </div>
<!--          <div class="link-list-item" :ref="linkBtns[0]" :class="{'active': isShowLinkBelow && linkListIndex==1}" @click="showLinkBelow(1)">
            <span>国家网站</span>
            <div class="arrow"></div>
          </div>-->
          <div class="link-list-item" :ref="linkBtns[1]" :class="{'active': isShowLinkBelow && linkListIndex==2}" @click="showLinkBelow(2)">
            <span>市级部门相关网站</span>
            <div class="arrow"></div>
          </div>
          <div class="link-list-item" :ref="linkBtns[2]" :class="{'active': isShowLinkBelow && linkListIndex==3}" @click="showLinkBelow(3)">
            <span>委属单位网站</span>
            <div class="arrow"></div>
          </div>
        </div>
        <div class="link-below-container" v-show="isShowLinkBelow">
<!--          <el-row v-if="linkListIndex == 1">
            <el-col class="item" :span="4" v-for="(item, index) in gjwzList" :key="index">
              <a @click="isShowLinkBelow=false" :href="item.linkUrl" target="_blank">{{ item.title }}</a>
            </el-col>
          </el-row>-->
          <el-row v-if="linkListIndex == 2">
            <el-col class="item" :span="4" v-for="(item, index) in cqszfList" :key="index">
              <a @click="isShowLinkBelow=false" :href="item.linkUrl" target="_blank">{{ item.title }}</a>
            </el-col>
          </el-row>
          <el-row v-if="linkListIndex == 3">
            <el-col class="item" :span="4" v-for="(item, index) in cqjxwList" :key="index">
              <a @click="isShowLinkBelow=false" :href="item.linkUrl" :title="item.title" target="_blank">{{ item.title }}</a>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="row">
        <div class="row-item">
          地址：{{ addressDetail }}
        </div>
      </div>
      <div class="row">
        <div class="row-item">{{ copyrightInfo }}版权所有</div>
      </div>
      <div class="row">
        <div class="row-item">
          <img class="icon-beian" src="@/assets/images/ga.png">渝公网安备 50011202500655号
        </div>
        <a class="row-item" target="_blank" href="https://beian.miit.gov.cn/">网站备案号：渝ICP备18007961号-2</a>
      </div>
    </div>
  </div>
</template>

<script>
import clickoutside from 'element-ui/src/utils/clickoutside'
import {reqOuterLink} from "@/api";

export default {
  directives: { clickoutside },
  name: "Footer",
  props: {
    addressDetail: {
      type: String,
      default: ''
    },
    copyrightInfo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShowLinkBelow: false,
      gjwzList: [],
      cqszfList: [],
      cqjxwList: [],
      linkListIndex: -1,
      linkBtns: [
        'btn1',
        'btn2',
        'btn3'
      ],
    }
  },
  methods: {
    showLinkBelow(linkListIndex = -1) {
      if(this.isShowLinkBelow && linkListIndex !== -1 && linkListIndex !== this.linkListIndex) {
        this.linkListIndex = linkListIndex
      } else if(this.isShowLinkBelow && linkListIndex !== -1 && linkListIndex === this.linkListIndex) {
        this.isShowLinkBelow = false
      } else {
        this.linkListIndex = linkListIndex
        this.isShowLinkBelow = !this.isShowLinkBelow
      }
    },
    async getGjwzList() {
      let result = await reqOuterLink(1)
      this.gjwzList = result.data
    },
    async getCqszfList() {
      let result = await reqOuterLink(2)
      this.cqszfList = result.data
    },
    async getCqjxwList() {
      let result = await reqOuterLink(3)
      this.cqjxwList = result.data
    },
  },
  mounted() {
    /* 初始化国家网站列表 */
    this.getGjwzList()
    /* 初始化重庆市政府网站列表 */
    this.getCqszfList()
    /* 初始化重庆市经信委网站列表 */
    this.getCqjxwList()
    /*document.addEventListener("click", e => {
      if(!this.isShowLinkBelow) {
        let count = 0
        for(let i=0; i<this.linkBtns.length; i++) {
          if(this.$refs.linkBtns[i].contains(e.target)) {
            break
          } else {
            count++
          }
        }
        if(count >= 3) {
          this.isShowLinkBelow = false
        }
      }
    })*/
  }
}
</script>

<style scoped lang="less">
.footer-container {
  position: relative;
  width: 100%;
  /*height: 384px;*/
  .link-container {
    width: 100%;
    height: 54px;
    background-color: #0052A8;
    .link-box {
      position: relative;
      z-index: 1;
      box-sizing: border-box;
      width: 1336px;
      height: 100%;
      margin: 0 auto;
      padding-right: 20px;
      padding-left: 54px;
      color: #FFF;
      display: flex;
      .link-below-container {
        box-sizing: border-box;
        position: absolute;
        z-index: 9;
        left: 0;
        top: 54px;
        width: 1336px;
        min-height: 220px;
        padding: 20px 78px;
        background-color: #FFF;
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
        box-shadow: 0 1px 1px 1px rgba(0,0,0,0.2);
        .item {
          margin-bottom: 18px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          position: relative;
        }
        a {
          position: relative;
          font-size: 16px;
          color: @baseTitleColor;
          &:hover {
            color: @baseTitleColor !important;
          }
        }
      }
      .slogan {
        width: 370px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        line-height: 60px;
        i {
          font-size: 26px;
          margin-right: 6px;
        }
        span {
          font-size: 20px;
          font-weight: 700;
        }
      }
      .link-list {
        box-sizing: border-box;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 54px;
        font-size: 16px;
        .link-list-item {
          cursor: pointer;
          display: flex;
          height: 100%;
          align-items: center;
          span {
            color: #FFF;
            margin-right: 10px;
          }
          .arrow {
            width: 0;
            height: 0;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            border-top-left-radius: 1px;
            border-top-right-radius: 1px;
            border-top: 7px solid #FFF;
            transition: transform 0.2s linear;
          }
          &.active {
            .arrow {
              transform: rotate(-180deg);
            }
          }
          a {
            color: #FFF;
            &:hover {
              color: #FFF !important;
            }
          }
        }
      }
    }
  }
  .content {
    box-sizing: content-box;
    width: 100%;
    height: 240px;
    background: #F7F7F7;
    color: #333;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .row {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      .row-item {
        margin-right: 20px;
        display: flex;
        align-items: center;
        .icon-beian {
          width: 20px;
          height: 20px;
          margin-right: 2px;
        }
      }
    }
  }
}
</style>
